import React from 'react';
import { Button, Col, FormGroup, ModalFooter } from 'reactstrap';

const ModelFooter = ({
  footerLoader,
  onModalToggle,
  footerLoadingText,
  footerButtonText,
  onSubmitButton = true,
  footerButtonCancelText,
}) => {
  return (
    <ModalFooter>
      <Col sm='12' className='text-center'>
        <FormGroup>
          {onSubmitButton && (
            <Button color=' ' type='submit' className='mr-2 btn-black radius-btn'>
              {footerLoader ? (
                <span>
                  <i className='fa fa-spinner fa-spin mr-1' /> {footerLoadingText || 'create'}
                </span>
              ) : (
                <span>{footerButtonText || 'Submit'}</span>
              )}
            </Button>
          )}{' '}
          <Button color=' ' onClick={onModalToggle} className='btn-line-black radius-btn'>
            {footerButtonCancelText}
          </Button>
        </FormGroup>
      </Col>
    </ModalFooter>
  );
};
export default ModelFooter;



// WEBPACK FOOTER //
// ./src/components/ModalComponent/ModelFooter.js